import _VTeamSelector from '@/views/team/components/v-selector';

export const VTeamSelector = _VTeamSelector